
import { defineComponent, ref, onMounted } from "vue";
import JwtService from "@/core/services/JwtService";
import ApiService from "@/core/services/ApiService";
import Notice from "@/components/Notice.vue";
import ShowUserQuestionAnswer from "@/views/pages/services/onlineQuestionnaire/component/ShowUserQuestionAnswer.vue";
import { useRoute } from "vue-router";
import { statusColor, translate } from "@/core/services/HelpersFun";
export default defineComponent({
  name: "multiple-messages",
  components: {
    Notice,
    ShowUserQuestionAnswer,
  },
  emits: ["getSelectedBot", "size-change", "handleSizeChange", "setGif"],
  setup() {
    const activeSessionKey = ref();
    const route = useRoute();
    const loading = ref(true);
    const list = ref();
    const listAnswers = ref();

    const sendMessageRef = ref();
    const pagination = ref();
    const pagination2 = ref();
    const page = ref(1);
    const page2 = ref(1);

    const getParticipants = () => {
      loading.value = true;
      ApiService.setHeader();
      ApiService.get(
        `/questionnaires/participants?name=${route.query.name}&bot_id=${route.query.bot_id}`
      ).then(({ data }) => {
        loading.value = false;
        list.value = data.data.participants.data;
        pagination.value = data.data.pagination;
      });
    };

    const getParticipantsAnswers = () => {
      loading.value = true;
      ApiService.setHeader();
      ApiService.get(
        `/questionnaires/answers?name=${route.query.name}&bot_id=${route.query.bot_id}`
      ).then(({ data }) => {
        loading.value = false;
        listAnswers.value = data.data.answers;
        pagination2.value = data.data.pagination;
      });
    };

    const excelLink = (id) => {
      return (
        process.env.VUE_APP_UPLOAD_FILE_URL +
        `/message/${id}/report/download?api_token=${JwtService.getToken()}`
      );
    };

    const handleSizeChange = (val: number) => {
      return;
    };
    const handleCurrentChange = (val: number) => {
      page.value = val;
      getParticipants();
    };

    onMounted(() => {
      getParticipants();
      getParticipantsAnswers();
    });

    return {
      list,
      listAnswers,
      loading,
      excelLink,
      pagination,
      handleCurrentChange,
      handleSizeChange,
      page,
      getParticipants,
      sendMessageRef,
      statusColor,
      translate,
      route,
      activeSessionKey,
    };
  },
});
